import { render, staticRenderFns } from "./tuiguangxiangqing_new.vue?vue&type=template&id=55860407&scoped=true"
import script from "./tuiguangxiangqing_new.vue?vue&type=script&lang=js"
export * from "./tuiguangxiangqing_new.vue?vue&type=script&lang=js"
import style0 from "./tuiguangxiangqing_new.vue?vue&type=style&index=0&id=55860407&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55860407",
  null
  
)

export default component.exports